<template>
  <div class="row mt-4" v-if="heatmap.length">
    <div class="col-12">
      <div class="card ficha-listado">
        <div class="px-4 pb-4 card-body">

          <div class="mb-3">
            <h6 class="mb-0 panel-section-title">Actividad horaria de ventas</h6>
            <p class="text-xs opacity-7 mb-0">Pedidos completados por día de la semana y franja horaria</p>
          </div>

          <!-- Leyenda + max -->
          <div class="d-flex align-items-center gap-3 mb-3 flex-wrap">
            <div class="hm-legend">
              <span class="hm-legend__label">Menos</span>
              <div class="hm-legend__bar">
                <div
                  v-for="s in legendSteps"
                  :key="s"
                  class="hm-legend__cell"
                  :style="{ background: colorFromRatio(s) }"
                ></div>
              </div>
              <span class="hm-legend__label">Más</span>
            </div>
            <span class="text-xs opacity-7">Máx: <strong>{{ maxVentas }}</strong> venta{{ maxVentas !== 1 ? 's' : '' }}</span>
          </div>

          <!-- Tabla heatmap -->
          <div class="hm-scroll">
            <table class="hm-table">
              <thead>
                <tr>
                  <th class="hm-th-day"></th>
                  <th
                    v-for="h in horas"
                    :key="h"
                    class="hm-th-hour"
                  >{{ h }}h</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(dia, dIdx) in dias" :key="dIdx">
                  <td class="hm-td-day">{{ dia }}</td>
                  <td
                    v-for="h in horas"
                    :key="h"
                    class="hm-cell"
                    :style="cellStyle(matrix[dIdx][h] || 0)"
                    :title="`${dia} ${h}:00 — ${matrix[dIdx][h] || 0} venta${(matrix[dIdx][h] || 0) !== 1 ? 's' : ''}`"
                  >
                    <span v-if="matrix[dIdx][h]" class="hm-cell__val">{{ matrix[dIdx][h] }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
const DIAS = ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"];
const HORAS = Array.from({ length: 24 }, (_, i) => i);

export default {
  name: "PanelTipsterHeatmap",
  props: {
    heatmap: { type: Array, default: () => [] },
  },
  data() {
    return {
      dias: DIAS,
      horas: HORAS,
      legendSteps: [0, 0.2, 0.4, 0.6, 0.8, 1],
    };
  },
  computed: {
    matrix() {
      // matriz[dia 0-6][hora 0-23] = ventas
      const m = Array.from({ length: 7 }, () => ({}));
      for (const r of this.heatmap) {
        if (r.dia >= 0 && r.dia <= 6) {
          m[r.dia][r.hora] = (m[r.dia][r.hora] || 0) + r.ventas;
        }
      }
      return m;
    },
    maxVentas() {
      let max = 0;
      for (const row of this.matrix) {
        for (const v of Object.values(row)) {
          if (v > max) max = v;
        }
      }
      return max;
    },
  },
  methods: {
    colorFromRatio(ratio) {
      if (ratio <= 0) return "#111926";
      const opacity = 0.15 + ratio * 0.85;
      return `rgba(245,166,35,${opacity.toFixed(2)})`;
    },
    colorFor(val) {
      if (!this.maxVentas || !val) return "#111926";
      return this.colorFromRatio(val / this.maxVentas);
    },
    cellStyle(val) {
      const bg = this.colorFor(val);
      if (!this.maxVentas || !val) return { background: bg };
      // A partir de ratio 0.45 el fondo es suficientemente oscuro para texto claro;
      // por debajo, texto oscuro para contraste con el dorado tenue
      const ratio = val / this.maxVentas;
      const color = ratio >= 0.45 ? "#1a1000" : "#e7c47a";
      return { background: bg, color };
    },
  },
};
</script>

<style scoped>
.hm-scroll { overflow-x: auto; -webkit-overflow-scrolling: touch; }

.hm-table {
  border-collapse: separate;
  border-spacing: 3px;
  min-width: 700px;
  width: 100%;
}

.hm-th-day { width: 38px; }
.hm-th-hour {
  font-size: 0.625rem;
  color: var(--q-muted);
  font-weight: 600;
  text-align: center;
  padding: 0 1px 4px;
  min-width: 28px;
}

.hm-td-day {
  font-size: 0.6875rem;
  font-weight: 700;
  color: var(--q-muted);
  white-space: nowrap;
  padding-right: 6px;
  text-align: right;
  vertical-align: middle;
}

.hm-cell {
  border-radius: 5px;
  height: 26px;
  min-width: 28px;
  text-align: center;
  vertical-align: middle;
  cursor: default;
  transition: filter .15s;
  position: relative;
}
.hm-cell:hover { filter: brightness(0.88); }

.hm-cell__val {
  font-size: 0.625rem;
  font-weight: 800;
  color: inherit;
  line-height: 26px;
  display: block;
}

/* Leyenda */
.hm-legend {
  display: flex;
  align-items: center;
  gap: 6px;
}
.hm-legend__label { font-size: 10px; color: var(--q-muted); }
.hm-legend__bar { display: flex; gap: 2px; }
.hm-legend__cell {
  width: 18px;
  height: 18px;
  border-radius: 3px;
}
</style>
